// Sdílený "jemný" red zvýrazňovací styl pro povinná pole, která jsou zatím
// prázdná (2026-09-04, na výslovné přání uživatele - "formuláře zvýrazni
// rovnou všechny povinné pole border jemný a červeně"). Použití: TextField
// s error={!value} + sx={requiredFieldSx} - přebíjí MUI výchozí sytě
// červenou (error.main) na jemnější error.light, jen mimo focus (aby
// focus ring zůstal standardní modrý).
export const requiredFieldSx = {
  '& .MuiOutlinedInput-root.Mui-error:not(.Mui-focused) .MuiOutlinedInput-notchedOutline': {
    borderColor: 'error.light'
  },
  '& .MuiFormHelperText-root.Mui-error': { color: 'error.light' },
  '& .MuiInputLabel-root.Mui-error': { color: 'error.light' }
};
